export const environment = {
  production: false,
  hmr: false,
  enableMaintenanceLogin: false,
  API_BASEURL: "https://api-old.nepta.dev",
  SITE_URL: "https://nepta.dev",
  CDN_URL: "https://cdn-old.nepta.dev",
  SOCKET_URL: "https://socket-old.nepta.dev",
  SHORTLINK_URL: "https://weteam-old.nepta.dev", 
  BASE_URL: "https://weteam-old.nepta.dev",
  PASS_KEY: "a4AOju8W+4RfMnC9h4bNfsWTjCGTE5obyTz3FUrhGD2E7MCenTde2w=="
};
